<template>
  <v-radio-group
    v-model="localModelValue"
    v-bind="{ ...$attrs, ...commonAttrs }"
    v-on="$listeners"
  >
    <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
    <v-radio
      v-for="(item, index) in items"
      :key="index"
      :label="item.label"
      :value="item.value"
    />
  </v-radio-group>
</template>

<script>

export default {
  name: 'RadioGroup',
  inheritAttrs: false,
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: [Boolean, Array, String],
      default: false,
    },
  },
  computed: {
    localModelValue: {
      get: function() {
          return this.modelValue;
      },
      set: function(value) {
          this.$emit('update:modelValue', value);
      }
    },
    commonAttrs() {
      return {
        hideDetails: this.$attrs.hideDetails || 'auto',
      };
    },
    items() {
      return this.$attrs['items'] || [];
    }
  },
}
</script>